import { useEffect, useRef } from "react";
import L from "leaflet";

// Fix leaflet default icon paths
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

function makeDivIcon(color, emoji) {
  return L.divIcon({
    className: "talabya-pin",
    html: `<div style="background:${color};width:38px;height:38px;border-radius:50%;border:4px solid #fff;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;box-shadow:0 6px 18px rgba(0,0,0,0.25);font-size:16px;">${emoji}</div>`,
    iconSize: [38, 38],
    iconAnchor: [19, 19],
  });
}

const RESTAURANT_ICON = makeDivIcon("#E05A3D", "🍽");
const DRIVER_ICON = makeDivIcon("#2C2825", "🏍");
const CUSTOMER_ICON = makeDivIcon("#798C58", "📍");

export default function MapView({
  center = [32.0665, 12.5303],
  zoom = 13,
  restaurant,
  driver,
  customer,
  className = "",
  height = "100%",
}) {
  const mapEl = useRef(null);
  const mapRef = useRef(null);
  const markersRef = useRef({});

  useEffect(() => {
    if (!mapEl.current || mapRef.current) return;
    const map = L.map(mapEl.current, {
      center,
      zoom,
      zoomControl: false,
      attributionControl: false,
    });
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
    }).addTo(map);
    L.control.zoom({ position: "topleft" }).addTo(map);
    mapRef.current = map;
    return () => {
      map.remove();
      mapRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    const upsert = (key, latlng, icon, label) => {
      if (!latlng) {
        if (markersRef.current[key]) {
          map.removeLayer(markersRef.current[key]);
          delete markersRef.current[key];
        }
        return;
      }
      if (markersRef.current[key]) {
        markersRef.current[key].setLatLng(latlng);
      } else {
        markersRef.current[key] = L.marker(latlng, { icon }).addTo(map);
        if (label) markersRef.current[key].bindTooltip(label, { direction: "top", offset: [0, -20] });
      }
    };
    upsert("rest", restaurant, RESTAURANT_ICON, "المطعم");
    upsert("drv", driver, DRIVER_ICON, "السائق");
    upsert("cus", customer, CUSTOMER_ICON, "العنوان");

    const pts = [restaurant, driver, customer].filter(Boolean);
    if (pts.length >= 2) {
      const bounds = L.latLngBounds(pts);
      map.fitBounds(bounds, { padding: [40, 40], maxZoom: 15 });
    } else if (pts.length === 1) {
      map.setView(pts[0], 14);
    }
  }, [restaurant, driver, customer]);

  return <div ref={mapEl} className={className} style={{ height, width: "100%" }} data-testid="map-view" />;
}
